import * as Constants from 'src/app/app.constants';

export const tenantConfig = {
  TENANT_LANGUAGE_PREFIX: 'TENANT_GALATONE.',
  COMUNE_DETAIL: {

    LOGO_URL: 'assets/imgs/logo.png',
    LOGO_URL_: 'assets/imgs/stemma-Galatone.png_',

    FACEBOOK_URL: 'https://www.facebook.com/comunegalatone/',
    GEOCODE_DEFAULT_LOCATION : {
      LATITUDE: 40.146842,
      LONGITUDE: 18.068782,
      ADDRESS: 'Galatone'
    }
  },
  GEOCODE_LOCATION_VIEWBOX: '18.22,40.30,17.90,40.00',
  BETA_IMAGE_BACKGROUND: true,
  BETA_IMAGE_CARD_OVER_BACKGROUND:  false,

  REngine: {
    distanceThresoldInPlace: 50, //Limite in km per capire se mi trovo in zona o a distanza

    query: {

      detail: {
        inplace: {
          algorithms:           ['collaborative', 'content', 'context'],
          collaborativeWeight:  0.5,
          contentWeight:        0.3,
          contextWeight:        0.2,
          searchType:           'all',
          num:                  3,
          maxSponsored:       1,

          maxDist:              50,
          similarityThreshold:  0,

        },
        remote: {
          algorithms:           ['collaborative', 'content', 'context'],
          collaborativeWeight:  0.3,
          contentWeight:        0.7,
          contextWeight:        0.0,
          searchType:         'similar',
          num:                3,
          maxSponsored:       1,

          maxDist:            50,
          similarityThreshold:  0,

        }
      },

      list: {
        inplace: {
          algorithms:           ['collaborative', 'content', 'context'],
          collaborativeWeight:  0.5,
          contentWeight:        0.3,
          contextWeight:        0.2,
          searchType:         'similar',
          num:                1,
          maxSponsored:       1,

          maxDist:            50,
          similarityThreshold:  0,

  
        },
        remote: {
          algorithms:           ['collaborative', 'content', 'context'],
          collaborativeWeight:  0.3,
          contentWeight:        0.7,
          contextWeight:            0.0,
          searchType:         'similar',
          num:                1,
          maxSponsored:       1,

          maxDist:            50,
          similarityThreshold:  0,
        }
  
      },

      homeNear: {
        inplace: {
          algorithms:           ['collaborative', 'content', 'context'],
          collaborativeWeight:  0.5,
          contentWeight:        0.3,
          contextWeight:            0.2,
          searchType:         'similar',
          num:                3,
          maxSponsored:       1,

          maxDist:            50,
          similarityThreshold:  0,
        },
        remote: {
          algorithms:           ['collaborative', 'content', 'context'],
          collaborativeWeight:  0.3,
          contentWeight:        0.7,
          contextWeight:            0.0,
          searchType:         'similar',
          num:                3,
          maxSponsored:       1,

          maxDist:            50,
          similarityThreshold:  0,
        }
      }

    },
 
  },

  MODE_APP_LOCALE:  'CITY', 
  



  /**
   * Configurazione dello slider
   * Per ogni item è possibile impostare un array di immagini dalle quali pescare
   * il campo Title è il testo che viene mostrato nel box
   * il buttonTitle è il testo del bottone
   * ATTENZIONE al campo buttonLinkUrl che è il codice da rispettare per recuperare la url dove mandare al click
   * IMG 657x343
   */
  HOME_SLIDER: [
    {
    images: [
      'assets/img/slider/slider_galatone-bg-02.jpg',
    ],
    title: 'HOME.CAROUSEL.ATTRACTORS.TEXT',
    buttonTitle: 'HOME.CAROUSEL.ATTRACTORS.LINK',
    buttonLinkUrl: 'ATTRACTORS'
  },
  {
    images: [
      'assets/img/slider/slider_restaurants.png'
    ],
    title: 'HOME.CAROUSEL.RESTAURANTS.TEXT',
    buttonTitle: 'HOME.CAROUSEL.RESTAURANTS.LINK',
    buttonLinkUrl: 'RESTAURANTS'
  },
  {
    images: [
      'assets/img/slider/slider_accomodations.png',
    ],
    title: 'HOME.CAROUSEL.ACCOMODATIONS.TEXT',
    buttonTitle: 'HOME.CAROUSEL.ACCOMODATIONS.LINK',
    buttonLinkUrl: 'ACCOMODATIONS'
 }
]

};

